import axios from "axios";
import CacheStorageService from "./cacheStorage.service";

class DocumentLogsService {
    constructor(apiUrl) {
        this.apiUrl = apiUrl;
    }


    /**
* @author Adrian Montemayor
* @description Get all documentlogs
* @date 02-10-2023
* @param {String} token
* @returns {Object}
* @memberof CompanyService
*/
    async getDocumentLogs(clientId, timezone, token, documentId) {
        // const cache = new CacheStorageService();
        // cache.deleteUrlFromCache('/categories')
        let url = `${this.apiUrl}/document-logs?clientId=${clientId}&timezone=${encodeURIComponent(timezone)}`
        if (documentId) {
            url = url + `&documentId=${documentId}`
        }

        let response = await axios.get(
            url,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    }

}

export { DocumentLogsService as default };
